import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BackgroundTimerService {
  private backgroundTimeouts: any[] = [];

  constructor() { }

  runAt(
    targetTimestamp: number,
    warningCallback: () => void,
    lastMinuteCallback: () => void,
    finalCallback: () => void
  ) {

    const now = Date.now();

    const firstWarning = targetTimestamp - now - 15 * 60 * 1000;
    const lastMinuteWarning = targetTimestamp - now - 60 * 1000;
    const lastWarning = targetTimestamp - now;

    // check for 15 min
    if (firstWarning > 0) {
      const firtsTimeout = setTimeout(() => {
        warningCallback();
      }, firstWarning);

      this.backgroundTimeouts.push(firtsTimeout);
    }
    else {
      warningCallback();
    }

    // check for 1 min
    if (lastMinuteWarning > 0) {
      const lastMinuteTimeout = setTimeout(() => {
        lastMinuteCallback();
      }, lastMinuteWarning);

      this.backgroundTimeouts.push(lastMinuteTimeout);
    }
    else {
      lastMinuteCallback();
    }

    // final check 
    if (lastWarning > 0) {
      const lastTimeout = setTimeout(() => {
        finalCallback();
      }, lastWarning);

      this.backgroundTimeouts.push(lastTimeout);
    }
    else {
      finalCallback();
    }

  }

  clear() {
    this.backgroundTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.backgroundTimeouts = [];
  }
}